import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { landingPageService, type HeroContent } from "../services/landingPageService";

interface LandingHeroState {
  data: HeroContent | null;
  loading: boolean;
  error: string | null;
}

const initialState: LandingHeroState = {
  data: null,
  loading: false,
  error: null,
};

export const fetchLandingHero = createAsyncThunk(
  "landingHero/fetch",
  async (_, { rejectWithValue }) => {
    try {
      return await landingPageService.getHero();
    } catch (err: any) {
      return rejectWithValue(
        err?.response?.data?.message || "Failed to fetch hero section"
      );
    }
  }
);

const landingHeroSlice = createSlice({
  name: "landingHero",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchLandingHero.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchLandingHero.fulfilled, (state, action: PayloadAction<HeroContent>) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchLandingHero.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export default landingHeroSlice.reducer;